/*
 *             Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
import _0x1fc77d from'./../../message.js';class SessionsConnectMessage extends _0x1fc77d{constructor(_0x23d822,_0x4c369d){super(),this['id']=_0x23d822,this['sessionType']=_0x4c369d;}['toJSON'](){return{'id':this['id'],'sessionType':this['sessionType']};}static['fromJSON'](_0x6d662e){return new SessionsConnectMessage(_0x6d662e['id'],_0x6d662e['sessionType']);}}SessionsConnectMessage['TYPE']='31',SessionsConnectMessage['READABLE_TYPE_NAME']='getConnectedSockets',SessionsConnectMessage['DESCRIPTOR_NAME']='SessionsConnectMessage',SessionsConnectMessage['DESCRIPTOR']={'fields':{'id':{'type':'string','id':0x1},'sessionType':{'type':'uint32','id':0x2}}};export default SessionsConnectMessage;